module.exports = __webpack_public_path__ + "img/ytube.8dd7bbd4.png";